export const VERSION="client20240126_1.0.1"

export default function gATracking(args) {
  const { event, payload, userCtx } = args
  if (event && userCtx) {
    window.dataLayer.push({
      event: event,
      staff_id: userCtx.session.user.staff_id,
      staff_membership_id: "", //pending
      organization_id: userCtx.session.user.organization_id,
      enterprise_id: userCtx.session.user.enterprise_id,
      user_role: userCtx.session.user.staff_role,
      version: VERSION,
      ...payload,
    })
  } else {
    return
  }
}
